module.exports = __webpack_public_path__ + "img/gift.8194e7b2.png";